import { jsx } from 'react/jsx-runtime';
import { createContext, useState, useMemo, useContext, useEffect } from 'react';
import { Status, FrameInner } from '@mwkt/magic-frame';

const MagicFrameInnerContext = createContext(null);
const MagicFrameInnerProvider = ({
  rootSelector,
  allowedOrigin,
  debugMode,
  children
}) => {
  const [status, setStatus] = useState(Status.Idle);
  const frameInner = useMemo(
    () => new FrameInner({
      rootSelector,
      allowedOrigin,
      debugMode,
      onStatusChange: (nextStatus) => {
        setStatus(nextStatus);
      }
    }),
    []
  );
  return /* @__PURE__ */ jsx(MagicFrameInnerContext.Provider, { value: { frameInner, status }, children });
};
const useFrameInner = ({ skip } = {}) => {
  const context = useContext(MagicFrameInnerContext);
  if (skip) {
    return null;
  }
  if (!context) {
    throw new Error("useFrameInner must be used within a MagicFrameInnerProvider");
  }
  return context.frameInner;
};
const useFrameInnerStatus = () => {
  const context = useContext(MagicFrameInnerContext);
  if (!context) {
    throw new Error("useFrameInnerStatus must be used within a MagicFrameInnerProvider");
  }
  return context.status;
};
const useWizardListener = ({
  event,
  callback,
  skip
}) => {
  const frameInner = useFrameInner({ skip });
  useEffect(() => {
    if (!frameInner) return () => {
    };
    frameInner.on(event, callback);
    return () => {
      frameInner.off(event, callback);
    };
  }, [frameInner]);
};
const useWizardEmit = ({ event, skip }) => {
  const frameInner = useFrameInner({ skip });
  return (data) => {
    if (!frameInner) return;
    frameInner.emitToWizard(event, data);
  };
};

export { MagicFrameInnerProvider, useFrameInner, useFrameInnerStatus, useWizardEmit, useWizardListener };
